class StickyScroll extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.mainEl = document.querySelector('.prd-Detail_Main')
    if (!this.mainEl) return

    this.observer = new ResizeObserver(() => {
      this.update()
    })
    this.observer.observe(this.mainEl)

    this.update()
  }

  update () {
    this.mainEl.style.setProperty(
      '--ProductMain_Height',
      `${this.mainEl.offsetHeight}px`,
    )
  }

  disconnectedCallback () {
    super.disconnectedCallback()

    if (this.observer) {
      this.observer.disconnect()
      this.observer = null
    }
  }
}

if (!customElements.get('sticky-scroll')) {
  customElements.define('sticky-scroll', StickyScroll)
}
